import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["onBackClick", "children"];
import { Box } from '@wix/design-system';
import React from 'react';
import { HeaderWrapper } from '../HeaderWrapper';
import { BngResultsTitle } from './BngResultsTitle';
import { AnonymousVoucherBanner } from '../../VoucherBanner';
export const BngResultsDesktopHeader = _ref => {
  let onBackClick = _ref.onBackClick,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: "SP3",
    marginBottom: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    paddingBottom: "SP3"
  }, /*#__PURE__*/React.createElement(AnonymousVoucherBanner, null)), /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    onBackClick: onBackClick
  }, props), /*#__PURE__*/React.createElement(BngResultsTitle, null)), children);
};
//# sourceMappingURL=BngResultsDesktopHeader.js.map